import { gql } from '@apollo/client';

export const CHANGE_OWN_PASSWORD = gql`
  mutation ChangeOwnPassword($input: ChangeOwnPasswordInput!) {
    changeOwnPassword(input: $input) {
      success
      message
      token
      refreshToken
    }
  }
`;

export interface ChangeOwnPasswordResult {
  changeOwnPassword: {
    success: boolean;
    message: string;
    token?: string | null;
    refreshToken?: string | null;
  };
}
